import { ApplicationRef } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsComparisonModule } from 'SecuritiesApp/ts/features/holdings-comparison/holdings-comparison.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { HoldingsComparisonComponent } from 'SecuritiesApp/ts/features/holdings-comparison/holdings-comparison.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class MutualFundsFundsHoldingsComparablesModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(HoldingsComparisonComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
MutualFundsFundsHoldingsComparablesModule.ɵfac = function MutualFundsFundsHoldingsComparablesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsFundsHoldingsComparablesModule)(); };
MutualFundsFundsHoldingsComparablesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsFundsHoldingsComparablesModule });
MutualFundsFundsHoldingsComparablesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsComparisonModule, StoreModule.forRoot({}, { metaReducers: getLogger() })] });
